import Tabs from '@mui/material/Tabs';

export { Tabs };
